import { Injectable } from '@angular/core';
import { AffiliateService } from '@deltager/organizers/admin/core/services/affiliate.service';

@Injectable({
  providedIn: 'root',
})
export class GTMService {
  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };

  constructor(private affiliateService: AffiliateService) {}

  public pushTag(item: object): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (!this.affiliateService.settings.googleTagManagerId) return resolve();

      this.pushOnDataLayer(item);
      return resolve();
    });
  }

  private getDataLayer(): any[] {
    const window = this.browserGlobals.windowRef();
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  private pushOnDataLayer(obj: object): void {
    const dataLayer = this.getDataLayer();
    dataLayer.push(obj);
  }

  public getGA4SessionId(): string | null {
    return (window as any).ga4SessionId || null;
  }

  public getGA4ClientId(): string | null {
    return (window as any).ga4ClientId || null;
  }
}
